<!-- 附近站点 -->
<template>
  <van-pull-refresh v-model="isLoading" @refresh="get_data" :disabled="true">
    <van-empty v-if="data.length == 0" description="站点加载中" />
    <div v-else class="site" v-for="(val, key) in data" :key="key">
      <oil-template :data="val"/>
    </div>
  </van-pull-refresh>
</template>

<style lang="scss" scoped>
 .site {
    margin-bottom: 10px;
    background: #fff;
    padding: 10px 15px;
  }
</style>
<script>

import oilTemplate from '@/components/site/site_template'

export default {
  name: 'site',
  components: {oilTemplate},
  data () {
    return {
      data: [],
      isLoading: false
    }
  },
  created () {
    this.get_data()
  },
  methods: {

    // 获取站点数据
    get_data () {
      this.get_site_data(this, true, (res) => {
        this.data = res
        this.isLoading = false
        this.$root.loadingAll = false
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/site/site.vue